// extracted by mini-css-extract-plugin
export default {"row":"MicropilesDeepPlaneSummary_row__s5gt9","table":"MicropilesDeepPlaneSummary_table__AfoVg","min120":"MicropilesDeepPlaneSummary_min120__tRsRb"};